<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content mt-4">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <!-- Header -->
              <div class="card-header">
                <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                    <h4 class="card-title">
                      LOT-{{ $route.query.id }} Order Details
                    </h4>
                    <img
                      id="logoId"
                      src="../../../public/images/logo.png"
                      style="width: 40px; height: 40px; display: none"
                    />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
                    <button
                      class="btn btn-success btn-sm ml-1"
                      type="button"
                      title="Excel"
                      @click.prevent="excelDownload($route.query.id)"
                    >
                      Excel <i class="fa fa-download"></i>
                    </button>
                    <b class="ml-3" style="font-size: 18px">Total: {{ listData.length }}</b>
                    <b class="ml-3" style="font-size: 18px"
                      >Scanned: {{ form.order_ids.length }}</b
                    >
                  </div>
                </div>
              </div>

              <!-- Scanner + Submit -->
              <div class="card-header">
                <div class="row justify-content-center">
                  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Scan or type order ID <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="itemId"
                        @keyup.enter="keepOrder"
                        placeholder="Scan barcode or type order id and press enter"
                      />
                    </div>
                  </div>
                  <div
                    class="col-xl-2 col-lg-2 col-md-3 col-sm-6"
                    style="margin-top: 30px"
                    v-if="form.order_ids.length > 0"
                  >
                    <button class="btn btn-info btn-sm" @click.prevent="submitData">
                      Submit
                    </button>
                  </div>
                </div>
              </div>

              <!-- Table -->
              <div class="card-body">
                <b-overlay :show="loader">
                  <div class="table-responsive">
                    <table
                      id="exportPdfTable"
                      class="table table-bordered table-striped table-sm"
                    >
                      <thead>
                        <tr>
                          <th>
                            <label style="cursor: pointer">
                              <input
                                type="checkbox"
                                v-model="selectAll"
                                @change="toggleSelectAll"
                              />
                              Order ID
                            </label>
                          </th>
                          <th>Order Date</th>
                          <th>Customer</th>
                          <th>Address</th>
                          <th>Soruce to Destination</th>
                          <th>Price (BDT)</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(order, index) in listData" :key="index">
                          <td>
                            <label>
                              <input
                                type="checkbox"
                                :value="order.id"
                                v-model="form.order_ids"
                                @change="checkSelectAll"
                              />
                              <p
                                class="d-inline ml-1"
                                style="cursor: pointer"
                                @click="toggleSingle(order.id)"
                              >
                                {{ order.id }}
                              </p>
                            </label>
                          </td>
                          <td @click="orderLog(order.logs)">
                            {{ order.date | dateformat }}
                          </td>
                          <td>{{ order.name + " " + order.mobile }}</td>
                          <td>{{ order.address }}</td>
                          <td>{{ order.source ? order.source.name : '' }} to {{ order.destination ? order.destination.name : '' }}</td>
                          <td>{{ order.price }}</td>
                          <td>
                            <span :class="'status-' + order.status">{{
                              getStatus(order.status)
                            }}</span>
                          </td>
                          <td>
                            <button class="btn btn-danger btn-sm ml-1" @click="orderNotFound(order)" title="Not Found"> Not Found </button>            
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-overlay>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Order Log Modal -->
    <div
      v-if="orderLogModal"
      class="modal fade show"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info text-white">
            <h5 class="modal-title text-center w-100">Order Log</h5>
            <button type="button" class="close" aria-label="Close" @click="cancelModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered table-sm">
              <tr>
                <th style="width: 20%">Action By</th>
                <th style="width: 55%">Action</th>
                <th style="width: 25%">Date & Time</th>
              </tr>
              <tr v-for="(log, index) in logs" :key="index">
                <td>{{ log.operation_by }}</td>
                <td>{{ log.operation }}</td>
                <td>{{ log.created_at | dateformat }} at {{ log.created_at | timeformat }}</td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" @click="cancelModal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Not found Modal -->
    <div v-if="notFoundModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <b-overlay :show="loader">
                <form v-on:keyup.enter="updatePickup">
                    <b-overlay :show="loader">
                        <div class="modal-content">
                            <div class="modal-header bg-info text-white">
                                <h5 class="modal-title text-center w-100">Order not Found !</h5>
                                <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                    <form @submit.prevent="handleSubmit(updateLot)">
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <ValidationProvider name="Total Order" vid="total_order" v-slot="{errors}" rules="required">
                                                    <div class="form-group">
                                                        <label for="total_order">Order ID</label>
                                                        <input type="text" id="total_order" v-model="form_edit.id" readonly="1" class="form-control" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');">
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </div> 
                                                </ValidationProvider>                         
                                            </div> 
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <ValidationProvider name="Time" vid="time" v-slot="{errors}" rules="required">
                                                    <div class="form-group">
                                                        <label for="time">Status <span class="text-danger" title="Required">*</span></label>
                                                        <v-select name="time"
                                                            style=""
                                                            v-model="form_edit.status"
                                                            label="text"
                                                            :reduce="item => item.id"
                                                            :options= statusList
                                                            :placeholder="$t('globalTrans.select')"
                                                        />
                                                        <span class="text-danger">{{ errors[0] }}</span>
                                                    </div>  
                                                </ValidationProvider>                      
                                            </div>
                                        </div>
                                    </form>
                                </ValidationObserver>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-info" @click.prevent="notFoundUpdate">{{ $t('globalTrans.submit') }}</button>
                                <button type="button" class="btn btn-danger" @click="cancelModal">{{ $t('globalTrans.cancel') }}</button>
                            </div>
                        </div>
                    </b-overlay>
                </form>
            </b-overlay>
        </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import "jspdf-autotable";

export default {
  name: "MakePaymentOrder",
  data() {
    return {
      orderLogModal: false,
      notFoundModal: false,
      loader: true,
      listData: [],
      logs: [],
      selectAll: false,
      itemId: "",
      form: {
        order_ids: [],
      },
      form_edit: null,
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: this.$store.state.commonObj.perPage,
        slOffset: 1,
      },
    };
  },
  created() {
    this.getOrders();
  },
  computed: {
    authUser() {
      return this.$store.state.authUser;
    },
    statusList () {
      return this.$store.state.statusList.filter(el => el.id === 10 || el.id === 41 || el.id === 42)
    }
  },
  methods: {
    async getOrders() {
      this.loader = true;
      const response = await config.getData(`/lot/details/${this.$route.query.id}`);
      this.loader = false;
      if (response.success) {
        this.listData = response.data.data;
      } else {
        this.listData = [];
      }
    },

    async excelDownload(id) {
      this.loader = true;
      try {
        const response = await config.getFile("excel-download/lot-details/" + id);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "LotDetails-" + id + ".csv");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.error({
          title: "Error",
          message: "Sorry, something went wrong",
          color: "#dc3545",
        });
      }
      this.loader = false;
    },

    orderNotFound(itemDetails) {
        this.form_edit = itemDetails
        console.log('form: ', this.form_edit)
        this.notFoundModal = true
    },
    async notFoundUpdate(){
      this.loader = true
      const response = await config.postData('/lot/order-not-found', this.form_edit)                
      this.loader = false
      if (response.success) {
        this.getOrders();
          this.notFoundModal = false;    
          this.$toast.success({
              title: 'Success',
              message: 'Order status updated successfully',
              color: '#218838'
          })
      } else {
          this.$refs.form.setErrors(response.errors)
          this.$toast.error({
              title: 'Error',
              message: 'Sorry, something went wrong',
              color: '#dc3545'
          })
      }
    },
    // toggle all checkboxes
    toggleSelectAll() {
      if (this.selectAll) {
        this.form.order_ids = this.listData.map((o) => o.id);
      } else {
        this.form.order_ids = [];
      }
    },

    // check if all selected, then auto check selectAll
    checkSelectAll() {
      this.selectAll =
        this.form.order_ids.length === this.listData.length && this.listData.length > 0;
    },

    // toggle single id on click
    toggleSingle(id) {
      const idx = this.form.order_ids.indexOf(id);
      if (idx === -1) {
        this.form.order_ids.push(id);
      } else {
        this.form.order_ids.splice(idx, 1);
      }
      this.checkSelectAll();
    },

    // handle barcode scan or manual entry
    keepOrder() {
      const id = parseInt(this.itemId);
      const found = this.listData.find((o) => o.id === id);
      if (!found) {
        this.$toast.error({
          title: "Error",
          message: "Sorry, order not found",
          color: "#dc3545",
        });
      } else if (!this.form.order_ids.includes(id)) {
        this.form.order_ids.push(id);
        this.checkSelectAll();
      }
      this.itemId = "";
    },

    orderLog(logs) {
      this.orderLogModal = true;
      this.logs = logs;
    },
    cancelModal() {
      this.orderLogModal = this.notFoundModal = false;
    },
    getStatus(status) {
      const tmpStatus = this.$store.state.statusList.find((tmp) => tmp.id == status);
      return typeof tmpStatus != "undefined" ? tmpStatus.text : status;
    },
    submitData() {
      console.log("Submitting selected order IDs:", this.form.order_ids);
      this.$toast.success({
        title: "Submitted",
        message: `${this.form.order_ids.length} orders submitted successfully`,
      });
    },
  },
};
</script>

<style scoped>
.d-inline {
  display: inline-block;
  padding-left: 3px;
}
</style>
